
import { Placement } from '@post-office/placements-frontend/jira-space-settings-nav-playbooks';
export default Placement;
